"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateField = exports.validateDateFormat = void 0;
var honeycomb_1 = require("@honeycomb-npm/honeycomb");
var PropTypes = require("prop-types");
var React = require("react");
var TextInputHelper_1 = require("../TextInputHelper");
var DateFieldComponent = /** @class */ (function (_super) {
    __extends(DateFieldComponent, _super);
    function DateFieldComponent(props) {
        var _this = _super.call(this, props) || this;
        /**
         * This function will determine whether the browser supports the HTML5 input type date.
         * If it doesn't, we need to manually handle the validation and formatting.
         */
        _this.isDateSupported = function () {
            if (typeof _this.state.dateSupported !== 'undefined') {
                return _this.state.dateSupported;
            }
            var input = document.createElement('input');
            input.setAttribute('type', 'date');
            input.setAttribute('value', 'a');
            var dateSupported = input.value !== 'a';
            _this.setState({
                dateSupported: dateSupported,
            });
            return dateSupported;
        };
        /**
         * When the field is required we validate that it has more than 0 characters.
         * When it has more than 1 character, the Validator.isDate() is used to return a different error message.
         */
        _this.validateRequired = function (input) {
            return honeycomb_1.Validators.minLength(input, 1);
        };
        /**
         * Validate the input value is a date string
         */
        _this.validateDate = function (input) {
            return honeycomb_1.Validators.isDate(input, _this.props.required);
        };
        /**
         * Validate the entered date is equal to or after the minimum date
         * This behaviour matches <input type="date" min="..." />
         */
        _this.validationMinDate = function (input) {
            var dateString = honeycomb_1.Formatters.formatDate(input, 'DD/MM/YYYY', 'YYYY-MM-DD');
            var inputDate = new Date(dateString + "T00:00:00.000Z");
            var minDate = new Date(_this.props.min + "T00:00:00.000Z");
            if (inputDate < minDate) {
                return false;
            }
            return true;
        };
        /**
         * Validate the entered date is equal to or less than the max date
         * This behaviour matches <input type="date" max="..." />
         */
        _this.validationMaxDate = function (input) {
            var dateString = honeycomb_1.Formatters.formatDate(input, 'DD/MM/YYYY', 'YYYY-MM-DD');
            var inputDate = new Date(dateString + "T00:00:00.000Z");
            var maxDate = new Date(_this.props.max + "T00:00:00.000Z");
            if (inputDate > maxDate) {
                return false;
            }
            return true;
        };
        _this.state = {};
        return _this;
    }
    DateFieldComponent.prototype.componentDidMount = function () {
        this.isDateSupported();
    };
    DateFieldComponent.prototype.render = function () {
        var _this = this;
        var attributes = __assign({}, this.props);
        if (typeof attributes.name === 'undefined') {
            attributes.name = attributes.id;
        }
        if (attributes.type === 'date' && this.state.dateSupported === false) {
            // Rollback to text field if input type date is not supported (IE11/Safari)
            attributes.type = 'text';
        }
        attributes.validators = [];
        if (attributes.required) {
            attributes.validators.push({
                errormessage: this.props.errormessage ? this.props.errormessage : 'This field is required',
                method: this.validateRequired,
            });
        }
        if (attributes.type === 'text') {
            // Add fallback for browsers that don't support the input type date
            // Validate the format
            attributes.validators.push({
                errormessage: 'Please enter the format "DD/MM/YYYY"',
                method: this.validateDate,
            });
            if (typeof attributes.onChange !== 'undefined') {
                // When an onChange callback exists, the value is converted from "DD/MM/YYYY" (<input type="text" /> format) to "YYYY-MM-DD"
                // (<input type="date" /> format) before it's sent to the props.onChange callback. When a new value is received from the props,
                // the value is converted back from "YYYY-MM-DD" format to "DD/MM/YYYY".
                // The user will enter the date in format "DD/MM/YYYY", but we store the value internally as "YYYY-MM-DD" to match input type date
                attributes.onChange = function (name, value, event) {
                    value = honeycomb_1.Formatters.formatDate(value, 'DD/MM/YYYY', 'YYYY-MM-DD');
                    if (_this.props.onChange) {
                        _this.props.onChange(name, value, event);
                    }
                };
                // Convert the date back from "YYYY-MM-DD" format into "DD/MM/YYYY"
                attributes.formatter = function (value) {
                    if (value.length === 0) {
                        return value;
                    }
                    return honeycomb_1.Formatters.formatDate(value, 'YYYY-MM-DD', 'DD/MM/YYYY');
                };
                attributes.value = attributes.formatter(attributes.value);
            }
        }
        if (attributes.min) {
            // Note the validation is still required on <input type="date" /> as the min/max
            // properties only control the calendar popup. The user is able to enter an invalid
            // date using the keyboard.
            var datestring = honeycomb_1.Formatters.formatDate(attributes.min, 'YYYY-MM-DD', 'DD/MM/YYYY');
            attributes.validators.push({
                errormessage: "Please enter a date on or after \"" + datestring + "\"",
                method: this.validationMinDate,
            });
        }
        if (attributes.max) {
            var datestring = honeycomb_1.Formatters.formatDate(attributes.max, 'YYYY-MM-DD', 'DD/MM/YYYY');
            attributes.validators.push({
                errormessage: "Please enter a date on or before \"" + datestring + "\"",
                method: this.validationMaxDate,
            });
        }
        return (React.createElement(TextInputHelper_1.TextInputHelper, __assign({}, attributes)));
    };
    return DateFieldComponent;
}(React.Component));
/**
 * Validate a date in format YYYY-MM-DD
 *
 * @param props
 * @param propName
 */
var validateDateFormat = function (props, propName) {
    if (typeof props[propName] === 'undefined' || props[propName].length === 0) {
        return;
    }
    // Check date format: 4 numbers, dash, 2 numbers, dash, 2 numbers
    var matches = props[propName].match(/^(\d{4,4})-(\d{2,2})-(\d{2,2})$/);
    if (matches === null) {
        return new Error("The \"" + propName + "\" should be in format \"YYYY-MM-DD\"");
    }
    // If both min and max were passed, check that the min is less than the max
    if (propName === 'max' && typeof props.min !== 'undefined') {
        var min = new Date(props.min);
        var max = new Date(props.max);
        if (max < min) {
            return new Error("The min date (" + props.min + ") must be less than the max date (" + props.max + ")");
        }
    }
    return;
};
exports.validateDateFormat = validateDateFormat;
/* tslint:disable:no-string-literal */
DateFieldComponent['defaultProps'] = {
    isValid: true,
    required: false,
    type: 'date',
};
DateFieldComponent['displayName'] = 'DateField';
DateFieldComponent['propTypes'] = {
    errormessage: PropTypes.string,
    helptext: PropTypes.string,
    id: PropTypes.string.isRequired,
    isValid: PropTypes.bool,
    label: PropTypes.string.isRequired,
    max: exports.validateDateFormat,
    min: exports.validateDateFormat,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    required: PropTypes.bool,
    type: PropTypes.oneOf(['date', 'text']),
    value: PropTypes.string,
};
/* tslint:enable:no-string-literal */
exports.DateField = React.forwardRef(function (props, ref) { return React.createElement(DateFieldComponent, __assign({}, __assign(__assign({}, props), { forwardedRef: ref }))); });
exports.DateField.displayName = 'Datefield';
